import { useToastContext } from '../contexts/ToastContext';

const useNotification = () => {
  const toast = useToastContext();

  const showNotification = (message, options = {}) => {
    return toast.showToast(message, options);
  };

  const showSuccess = (message, options = {}) => {
    return toast.success(message, options);
  };

  const showError = (message, options = {}) => {
    return toast.error(message, options);
  };

  const showWarning = (message, options = {}) => {
    return toast.warning(message, options);
  };

  const showInfo = (message, options = {}) => {
    return toast.info(message, options);
  };

  const removeNotification = (id) => {
    toast.removeToast(id);
  };

  const clearAllNotifications = () => {
    toast.clearAllToasts();
  };

  return {
    showNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    removeNotification,
    clearAllNotifications,
  };
};

export default useNotification;
